var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "message", class: ["message", _vm.customClass] },
    [
      _vm.showDecoration
        ? _c("font-awesome-icon", {
            class: ["decorative", _vm.iconClass],
            attrs: { icon: _vm.$v7[_vm.iconStyle][_vm.iconName] },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("h4", { staticClass: "title" }, [_vm._v(_vm._s(_vm.messageTitle))]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }